<template>
    <div class="m-panel">
        <div class="m-panel-bar">
            <div class="m-panel-bar-title">
                {{title}}
            </div>
        </div>
        <div class="m-panel-body">
          <div class="fixed">
            <div class="header-item">{{ $t('厂家名称') }}</div>
            <div class="header-item">{{ $t('水表总数') }}</div>
            <div class="header-item">{{ $t('远传/非远传') }}</div>
            <div class="header-item">{{ $t('传输方式') }}</div>
          </div>
          <div style="overflow: hidden;height: calc(100% - 30px);">
            <ul class="list-ul">
                <li class="list-row" v-for="(item, index) in list" :key="index">
                  <div class="list-item">{{ item.name }}</div>
                  <div class="list-item">{{ item.num }}</div>
                  <div class="list-item">{{ item.isYc }}</div>
                  <div class="list-item">{{ item.type }}</div>
                </li>
              </ul>
          </div>
        </div>
    </div>
</template>
<script>
import { postAction } from '@/api/manage'
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  components: {
      vueSeamlessScroll
  },
    data() {
        return{
            title: this.$t('水表厂家情况汇总'),
            url:{
              list: "/jeecg-charge/meter/meterReadingLargeScreen/queryLargeScreenMeterFactory",
            },
            pageNo: 1,
            pageSize: -10,
            errorNum: 0,
            list:[
                {name: '厂家1',num: 400,isYc:'远传',type:'NB-IOT'},
                {name: '厂家2',num: 200,isYc:'远传',type:'NB-IOT'},
                {name: '厂家3',num: 70,isYc:'远传',type:'NB-IOT'},
                {name: '厂家4',num: 270,isYc:'远传',type:'NB-IOT'},
                {name: '厂家5',num: 170,isYc:'远传',type:'NB-IOT'},
                {name: '厂家6',num: 300,isYc:'远传',type:'NB-IOT'},
            ],
        }
    },
    mounted() {},
    methods: {
      init() {
        this.resetData();
        this.getData();
      },
      resetData() {
          this.list = this.$options.data.call(this).list
      },
      getData(){
        this.list = [];
        postAction(this.url.list,{}).then(res=>{
          if(res.success){
            res.result.xdata.pop();
            res.result.xdata.map((item,index)=>{
              this.list.push({
                name:item,
                num: res.result.ydata[index].num,
                isYc: this.$t('远传'),
                type: 'NB-IOT'
              })
            })
          }
        })
      }
    },
}
</script>
<style lang="less" scoped>
  .fixed {
    display: flex;
    align-items: center;
    // justify-content: space-around;
    background-color: #08306F;
    // margin: 10px 3px;
    // padding: 0 10px;
    color: #FFF;
    height: 30px;
  
    .header-item {
      width: 28.33%;
      text-align: center;
    }
  
    .header-order {
      width: 15%;
      text-align: center;
    }
  }
  
  .plant-bg {
    height: calc(100% - 40px);
    overflow: hidden;
    // background: url(../../../assets/img/plant5.png) center center no-repeat;
    // background-size: 100% 100%;
  }
  
  .list-ul {
    /* width: 100%;
      background: #f67;
      display: flex;
      justify-content: space-between; */
  }
  
  .list-row {
    // margin: 0 20px;
    color: #b6deff;
    display: flex;
    height: 33px;
    align-items: center;
    line-height: 35px;
    border: 1px solid #011a3a;
    // background: url(../../../assets/img/list-bg.png) center no-repeat;
    // background-size: 100% 100%;
  
    .order {
      // background: #0989ff;
      width: 48px;
      height: 18px;
      // border: 2px solid #0759a5;
      border-radius: 2px;
      text-align: center;
      line-height: 18px;
      color: #fff;
    }
  }
  
  .list-row .list-item {
    width: 28.33%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    color: #fff;
  }
  
  .list-order {
    width: 15%;
    display: flex;
    justify-content: center;
  }
  
  .fill-cicle {
    height: 10px;
    width: 10px;
    border-radius: 10px;
    box-shadow: 0 0 5px 5px rgba(255, 0, 0, 0.5);
  }
  
  ul {
    padding-inline-start: 0;
  }
  
  .seamless-warp {
    height: 100%;
  }
  
  .seamless-warp:hover {
    overflow-y: scroll;
  }
  
  .seamless-warp::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  
  .seamless-warp::-webkit-scrollbar-track {
    background: #0e0c4f;
    border-radius: 2px;
  }
  
  .seamless-warp::-webkit-scrollbar-thumb {
    background: #292f88;
    border-radius: 2px;
  }
  
  .seamless-warp::-webkit-scrollbar-corner {
    background: #0e0c4f;
  }
  .state0{
    color: #f5f5f5;
  }
  .state1{
    color: #4634FA;
  }
  .state2{
    color: #F6BB2F;
  }
  .state3{
    color: #50E3C2;
  }
  .state4{
    color: #32C5FF;
  }
  .state5{
    color: #0091FF;
  }
  .state6{
    color: #0394FF;
  }
  .state7{
    color: #0C2D82;
  }
  .state8{
    color: #B620E0;
  }
  .state9{
    color: #F7B500;
  }
  .state10{
    color: #FA6400;
  }
  .state11{
    color: #E02020;
  }
</style>